var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.loaded)?_c('div',{staticClass:"text-center"},[_vm._v("No Data")]):_c('apexchart',{attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.series,"labels":_vm.labels,"height":"200"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }